import { CommonRequestOptions, makeRequest } from '../makeRequest';

type GetExternalTrainingModuleUsageResponse = {
   usage: {
      parent_link: string;
      parent_title: string;
   }[];
};

export async function getExternalTrainingModuleUsage(
   moduleId: number,
   common: CommonRequestOptions = {}
): Promise<GetExternalTrainingModuleUsageResponse> {
   return makeRequest('get', `/external-training-modules/${moduleId}/usage`, common);
}
